import { createAsyncThunk } from "@reduxjs/toolkit";
import dataService from "@/endpoints/dataService";

export const updateQuestionOptionColor = createAsyncThunk<
  { entityId: number; color: string; entityType: "RESPONSE" | "USER_ROLLUP" } | null,
  { questionGroup: string; entityId: number; color: string; entityType: "RESPONSE" | "USER_ROLLUP" },
  { rejectValue: string }
>(
  "questions/updateQuestionOptionColor",
  async ({ questionGroup, entityId, color, entityType }, thunkAPI) => {
    try {
      const response: any =
        await dataService.questions.updateQuestionOptionColor(
          questionGroup,
          entityId,
          color,
          entityType
        );
      if (response) {
        return {
          entityId,
          color,
          entityType,
        };
      }
      return null;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        "Failed to update question option color" + err.message
      );
    }
  }
);

export const createRollup = createAsyncThunk<any, any, { rejectValue: string }>(
  "questions/createRollup",
  async ({ payload }, thunkAPI) => {
    try {
      const response: any = await dataService.questions.createRollup(payload);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue("Failed to create rollup" + err.message);
    }
  }
);
